var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header", [
        _c("h3", [_vm._v("Lab颜色空间及相关数值意义")]),
        _c("p", [_vm._v(_vm._s(_vm.titleDesc))])
      ]),
      _c("faceResult", {
        attrs: { result: _vm.result.faceResult, url: _vm.result.faceUrl }
      }),
      _c("tongueResult", {
        attrs: { result: _vm.result.tongueResult, url: _vm.result.tongueUrl }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }